import { Segmented, Switch, Space } from "antd";

export default function EngagementToolbar({
                                              chartType, setChartType,
                                              isStacked, setIsStacked,
                                              displayMode, setDisplayMode,
                                          }) {
    const onViewChange = (val) => {
        if (val === "table") {
            setDisplayMode("table");
            return;
        }
        // val is "line" or "bar"
        setDisplayMode(val);
        setChartType(val);
    };

    const effectiveView = displayMode === "table" ? "table" : chartType;

    return (
        <Space wrap style={{ width: "100%", justifyContent: "flex-end" }}>
            <Segmented
                size="small"
                value={effectiveView}
                onChange={onViewChange}
                options={[
                    { label: "Line", value: "line" },
                    { label: "Bar",  value: "bar"  },
                    { label: "Table", value: "table" },
                ]}
            />
            {displayMode !== "table" && (
                <Switch
                    size="small"
                    checkedChildren="Stacked"
                    unCheckedChildren="Grouped"
                    checked={isStacked}
                    onChange={setIsStacked}
                />
            )}
        </Space>
    );
}
